import type { EntryPointComponent } from 'react-relay';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { Route } from '@atlassian/react-resource-router';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsIssuesExplicitFieldAssociationRoute } from '@jira/router-routes__admin-pages-issues-explicit-field-association-routes/src/globalSettingsIssuesExplicitFieldAssociationRoute.tsx';
import {
	LazyExplicitFieldsProjectListPage,
	LazyExplicitFieldsProjectListPromise,
} from './ui/spa/index.tsx';

const EMPTY_OBJECT = {};
const globalSettingsIssuesExplicitFieldAssociationPageEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-error-pages-not-found", jiraSpaEntry: "async-error-pages-not-found" */ '@jira/spa-apps__error-pages-not-found/src/ErrorPagesNotFoundPage.tsx',
			{ entryFsSsrLiftImportToModule: true },
		),
		getPreloadProps: () => EMPTY_OBJECT,
	},
});

export const globalSettingsIssuesExplicitFieldAssociationRouteEntry: Route = createEntry(
	globalSettingsIssuesExplicitFieldAssociationRoute,
	() => ({
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
		},

		resources: [...getNavigationResources(), navigationSidebarGlobalResource],

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_batch_4')
			? undefined
			: LazyExplicitFieldsProjectListPage,

		entryPoint: () =>
			fg('nike_entrypoint_migration_batch_4')
				? globalSettingsIssuesExplicitFieldAssociationPageEntryPoint
				: undefined,
		forPaint: [LazyAtlassianNavigation, LazyExplicitFieldsProjectListPromise],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
